import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

function StaffBlockedCommentsPage() {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadComments = async () => {
    try {
      const res = await staffFetch(`${API}/staff/blocked-comments`);
      const data = await res.json();

      if (data.success) {
        setComments(data.comments || []);
      } else {
        alert(data.message || "Impossible de charger");
      }
    } catch (error) {
      console.log("Erreur StaffBlockedComments:", error);
      alert("Connexion serveur impossible");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadComments();
  }, []);

  const handleAction = async (id, type) => {
    try {
      await staffFetch(`${API}/staff/blocked-comments/${id}/${type}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      });

      loadComments();
    } catch {
      alert("Action impossible");
    }
  };

  const getVideoUrl = (path) => {
    if (!path) return "";

    if (path.startsWith("http")) {
      return path;
    }

    return `https://live-evo.com/uploads/${path}`;
  };

  const getProfileUrl = (path) => {
    if (!path || path === "default.png") {
      return "https://live-evo.com/uploads/default.png";
    }

    if (path.startsWith("http")) {
      return path;
    }

    return `https://live-evo.com/uploads/${path}`;
  };

  if (loading) {
    return (
      <div style={center}>
        Chargement des commentaires...
      </div>
    );
  }

  return (
    <div style={container}>
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <div style={topBar}>
          <button
            onClick={() => {
              window.location.href = "/staff";
            }}
            style={backBtn}
          >
            ← Retour
          </button>

          <div style={title}>
            Commentaires bloqués
          </div>
        </div>

        {comments.length === 0 ? (
          <div style={emptyBox}>
            Aucun commentaire bloqué.
          </div>
        ) : (
          comments.map((item) => (
            <div
              key={item.id}
              style={card}
            >
              <div style={headerRow}>
                <img
                  src={getProfileUrl(item.profile_picture)}
                  alt=""
                  style={avatar}
                />

                <div style={{ flex: 1 }}>
                  <div style={pseudo}>
                    @
                    {item.user_pseudo ||
                      item.current_user_pseudo ||
                      "Utilisateur"}
                  </div>

                  <div style={email}>
                    {item.user_email}
                  </div>
                </div>

                <div style={statusBadge}>
                  {item.status || "ouvert"}
                </div>
              </div>

              <div style={commentBox}>
                <div style={label}>
                  Commentaire bloqué
                </div>

                <div style={commentText}>
                  {item.content}
                </div>
              </div>

              <div style={infoRow}>
                <div style={infoLabel}>
                  Raison :
                </div>

                <div style={infoValue}>
                  {item.reason || "Non précisée"}
                </div>
              </div>

              <div style={infoRow}>
                <div style={infoLabel}>
                  Vidéo ID :
                </div>

                <div style={infoValue}>
                  {item.video_id}
                </div>
              </div>

              {item.video_description && (
                <div style={videoBox}>
                  <div style={label}>
                    Description vidéo
                  </div>

                  <div style={videoDescription}>
                    {item.video_description}
                  </div>
                </div>
              )}

              {item.video_file_path && (
                <div style={videoPath}>
                  Fichier vidéo :
                  {" "}
                  {getVideoUrl(item.video_file_path)}
                </div>
              )}

              <div style={actions}>
                <button
                  style={acceptButton}
                  onClick={() =>
                    handleAction(item.id, "warn")
                  }
                >
                  Valider blocage
                </button>

                <button
                  style={reviewButton}
                  onClick={() =>
                    handleAction(item.id, "review")
                  }
                >
                  À vérifier
                </button>

                <button
                  style={closeButton}
                  onClick={() =>
                    handleAction(item.id, "close")
                  }
                >
                  Fermer
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const container = {
  minHeight: "100vh",
  background: "#05070d",
  padding: 14,
  color: "#fff"
};

const topBar = {
  marginBottom: 20
};

const backBtn = {
  background: "transparent",
  border: "none",
  color: "#00f2ff",
  fontSize: 15,
  marginBottom: 12,
  cursor: "pointer"
};

const title = {
  color: "#fff",
  fontSize: 24,
  fontWeight: "800"
};

const card = {
  background: "#0d111a",
  borderRadius: 18,
  padding: 14,
  marginBottom: 14,
  border: "1px solid rgba(0,242,255,0.20)"
};

const headerRow = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  marginBottom: 14
};

const avatar = {
  width: 48,
  height: 48,
  borderRadius: "50%",
  objectFit: "cover",
  background: "#111"
};

const pseudo = {
  color: "#fff",
  fontSize: 16,
  fontWeight: "800"
};

const email = {
  color: "#8fa6ad",
  fontSize: 12,
  marginTop: 2
};

const statusBadge = {
  background: "rgba(0,242,255,0.12)",
  border: "1px solid #00f2ff",
  padding: "5px 10px",
  borderRadius: 20,
  color: "#00f2ff",
  fontWeight: "700",
  fontSize: 12
};

const commentBox = {
  background: "#121827",
  borderRadius: 14,
  padding: 12,
  marginBottom: 12
};

const label = {
  color: "#00f2ff",
  fontSize: 12,
  fontWeight: "800",
  marginBottom: 6
};

const commentText = {
  color: "#fff",
  fontSize: 16,
  fontWeight: "700"
};

const infoRow = {
  display: "flex",
  gap: 10,
  marginBottom: 8
};

const infoLabel = {
  color: "#8fa6ad",
  width: 90
};

const infoValue = {
  color: "#fff",
  flex: 1
};

const videoBox = {
  background: "#101522",
  borderRadius: 12,
  padding: 10,
  marginTop: 8
};

const videoDescription = {
  color: "#fff"
};

const videoPath = {
  color: "#8fa6ad",
  fontSize: 11,
  marginTop: 10
};

const actions = {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  marginTop: 14
};

const acceptButton = {
  flex: 1,
  background: "#00c853",
  padding: 12,
  borderRadius: 14,
  border: "none",
  color: "#fff",
  fontWeight: "800",
  cursor: "pointer"
};

const reviewButton = {
  flex: 1,
  background: "#ff9500",
  padding: 12,
  borderRadius: 14,
  border: "none",
  color: "#fff",
  fontWeight: "800",
  cursor: "pointer"
};

const closeButton = {
  flex: 1,
  background: "#ff2d55",
  padding: 12,
  borderRadius: 14,
  border: "none",
  color: "#fff",
  fontWeight: "800",
  cursor: "pointer"
};

const emptyBox = {
  marginTop: 80,
  textAlign: "center",
  color: "#8fa6ad"
};

const center = {
  minHeight: "100vh",
  background: "#05070d",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#00f2ff"
};

export default StaffBlockedCommentsPage;
